module.exports = __webpack_public_path__ + "static/media/researchgate.96355005.svg";